import {EventEmitter, Injectable} from '@angular/core';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {ContentScope, PlatformCommand} from '@shared/commands/command-base';
import {ActivatedRoute, Router} from '@angular/router';
import { Configuration } from '@shared/models/configuration';
import { ParticleCacheService } from '@core/services/particle-cache.service';

import { DialogService } from '@shared/services/dialog-service';
import { SyncProjectEntityToCompanyCommand, UpdatePreArrangementCommand, ArchiveSingleCaseCommand, UnarchiveCaseCommand, PreArrangeMentsDeleteCommand, CreatePreArrangementFromExistingCaseCommand, CreatePreArrangementCommand, CreateArrangementCommand, SaveSelectedCaseModelsInLeftSideOfTheTransferboxCommand, ArchiveCaseCommand } from '../commands/dac6-reporter.command';
import { CommandService } from '@core/services/command.service';
import { UpdateFieldDefinitionCommand } from '@shared/commands/update-field-definition.command';
import { ParticleConfig } from '@features/particle-config';
import { BasketProvider } from '@shared/models/basket-provider';
import { BasketId } from '../Fields';
import { SnackBarService } from '@core/services/snack-bar.service';
import { FileStoreCommonService } from '@features/file-manager/services/file-store-common.service';
import { CreateChatConversationCommand } from '@features/task-manager/collaboration/store/collaboration.command';
import { CreateChatConversationAction } from '@features/task-manager/collaboration/store/collaboration.action';
import { ConversationComponentName } from '@features/task-manager/collaboration/store/collaboration.constants';
import { Store } from '@ngrx/store';
import { CollaborationState } from '@features/task-manager/collaboration/store/collaboration.reducer';
import { DialogModel } from '@shared/models/dialog.model';
import { takeUntil, take } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { FuseSplashScreenService } from '@barebone-fuse/@fuse/services/splash-screen.service';
import { PlatformSidebarState } from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import { SetActivityFeedAction } from '@shared/components/platform-sidebar/store/platform-sidebar.action';
import { ParticleService } from '@core/services/particle.service';
import { Dac6CellDecoratorComponent } from '../components/dac6-cell-decorator/dac6-cell-decorator.component';
import { BasketModel } from '@shared/models/common.models';
import { Dynamic_Grid_Data_Request_Parameters } from '@shared/store/actions/virtual-grid.actions';
import {CleanWorkflowDataAction} from '@features/workflow/store/workflow.actions';
import {IDac6ReporterState} from '@features/dac6-reporter/store/reducers/dac6-reporter.reducer';


@Injectable({
  providedIn: 'root',
})
export class PlatformToolDac6PreArrangementHandler implements IPlatformToolHandler {


  constructor(private particleCacheService: ParticleCacheService, private store: Store<IDac6ReporterState>,
    private dialogService: DialogService,
    protected commandService: CommandService,
    private snackBarService: SnackBarService,
    private fileStoreCommonService: FileStoreCommonService,
    private collaborationStore: Store<CollaborationState>,
    private fuseSplashScreenService: FuseSplashScreenService,
    private platformSidebarStore: Store<PlatformSidebarState>,
    private particleService: ParticleService,
    private router: Router) {
    this.showArchived = false;
    this.invalidateSubject = new InvalidateSubject();
    particleService.registerCellComponent('Dac6CellDecorator', Dac6CellDecoratorComponent);
  }
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  magicLinkModelValueChanged: EventEmitter<any>;
  selectedTab:TabModel;
  activatedRoute?: ActivatedRoute;
  metaData?: any;

  sourceType = 'PreArrangement';
  fieldHistorySourceType: string = 'Dac6-Field-History';
  unSubscribe$ = new Subject<void>();
  showArchived: boolean;
  selectedBasket: BasketModel;
  setSelectedTab(selectedTab: TabModel): void {
    this.selectedTab = selectedTab;
    if (this.magicLinkModel.fieldValues['WorkflowTool'] === 'Export') {
      this.handleExport();
    } else if (this.magicLinkModel.fieldValues['WorkflowTool'] === 'Import') {
      this.magicLinkModel.fieldValues['Parameters'] = {
        'ImportSampleExcelTemplateName': this.magicLinkModel.fieldValues['ImportSampleExcelTemplateName'],
        'TOOL_NAME': this.magicLinkModel.fieldValues['TOOL_NAME']
      };
    }
  }
  private handleExport() {
    let includeArchives = false;
    const selectedSourceType = this.magicLinkModel.fieldValues['ExportSelectedSourceType'];
    const notSelectedSourceType = this.magicLinkModel.fieldValues['ExportNotSelectedSourceType'];
    const selected = Configuration.getSmartGridConfig(selectedSourceType);
    const notSelected = Configuration.getSmartGridConfig(notSelectedSourceType);
    //
    const filingType = this.activatedRoute.snapshot.params['filingType'];
    if (filingType) {
      selected.Parameters['FILING_TYPE'] = filingType;
      notSelected.Parameters['FILING_TYPE'] = filingType;
    }
    if (this.activatedRoute.snapshot.params['includeArchives']) {
      includeArchives = this.activatedRoute.snapshot.params['includeArchives'];
      selected.Parameters['INCLUDE_ARCHIVES'] = includeArchives;
      notSelected.Parameters['INCLUDE_ARCHIVES'] = includeArchives;
    }
  }
  executeCommand(command: PlatformCommand) {
    switch (command.name) {
      case 'BasketChangedCommand':
        this.changeBasket(command.fieldValues['CurrentBasket']);
        break;
      case 'CreatePreArrangementCommand':
        this.createCase();
        break;
      case 'ImportPreArrangementCommand':
        this.import();
        break;
      case 'ExportPreArrangementCommand':
        this.exportPreArrangement();
        break;
      case 'CreateManageFieldMagicLinkCommand':
         this.manageSection();
         break;
      case 'ArchiveCasesCommand':
        this.archive();
        break;
      case 'ShowArchivedCommand':
        this.showArchivedChanged(command);
        break;
      case 'CreateParticipantsSurveyCommand':
        this.startDataSurvey();
        break;
      case 'WorkflowCleanupCommand':
        this.cleanupWorkFlow(command);
        break;
      default:
        this.executeCommandToApi(command);
        break;
    }
  }
  changeBasket(Basket: BasketModel){
    this.selectedBasket = Basket;
  }
  valueChanged(event: any) {
    if (event.fieldDefinition && event.fieldDefinition.key === 'CaseId') {
      if (!event.item.isReadOnly) {
        this.openPreArrangementDetail(event.item.id);
      }
      return;
    }
    if (event.fieldDefinition && event.fieldDefinition.key === 'Suggested_Hallmarks') {
      this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition, '500px', '500px').subscribe();
      return;
    }
    if (event.action) {
      switch (event.action.id) {
        case 'Open':
            this.openPreArrangementDetail(event.item.id);
          break;
        case 'OpenHallmarkQuestion':
          this.navigateToDetailViewerTab(event.fieldDefinition, event.item);
          break;
        case 'Edit':
          this.edit(event);
          break;
        case 'itemClick':
          this.handleItemClick(event);
          break;
        case 'OpenCaseFolder':
          let viewDocumentCommand = new PlatformCommand('ViewDocumentActivityCommand','Dac6Api');
          var sourceKey = BasketProvider.getRootSourceKeyBySourceType(event.item.type);
          viewDocumentCommand.fieldValues['SourceType'] = sourceKey;
          // viewDocumentCommand.fieldValues[sourceKey+"Id"] = event.item.id;
          viewDocumentCommand.fieldValues['CaseId'] = event.item.id;
          this.commandService.executePlatformCommand(viewDocumentCommand).pipe(take(1)).subscribe(response => {
              console.log('commandState', response);
            },
            error => {
              console.error('Failed to basket manage section', error);
            });
          this.navigateToCaseFolder(event);
          break;
        case 'Start Conversation':
          this.startConversationActivity(event);
          this.getChatForThisCase(event);
          break;
        case 'ArchiveCase':
          this.archiveSingle(event.item.cells['CaseGUID'].value);
          break;
        case 'UnarchiveCase':
          this.unarchiveCase(event.item.cells['CaseGUID'].value);
          break;
        case 'Move to Arrangements':
          if (!event.item.isReadOnly) {
            this.router.navigateByUrl(`dac6-reporter/pre-arrangement/prearrangement-to-arrangement/${event.item.id}`);
          }
          break;
        case 'Delete':
          const command = new PreArrangeMentsDeleteCommand([event.item.id]);
          this.commandService.executeCommand(command).subscribe(state => {
            if (state) {
              this.invalidateSubject.invalidate();
              this.snackBarService.showInformation('Pre-Arrangement Deleted Successfully');
            }
          });
          break;
        case 'Copy':
          this.copyCase(event);
          break;
        case 'ViewActivity':
          this.trackCaseActiviy(event);
          break;
      }
    }
    console.log(event);
  }

  selectionChanged?($event: any): void {
    throw new Error("Method not implemented.");
  }

  private openPreArrangementDetail(preArrangementId: string) {
    this.router.navigateByUrl(`dac6-reporter/pre-arrangement/detail/${preArrangementId}`);
  }

  private navigateToDetailViewerTab(fieldDefinition, item) {
  }

  edit(event: any) {
    console.log('Something Is Happening');
    if (event.fieldDefinition.cellEditor === 'EntityTextCellEditor') {
      // Sync
      const command = new SyncProjectEntityToCompanyCommand(false);
      this.commandService.executeCommand(command).pipe().subscribe(commandState => {
        console.log(commandState);
        if (commandState.Payload.ConfirmationNeeded) {
          this.dialogService.showYesNoDialog('Confirm Sync', `You were working with the entities of project '${commandState.Payload.Configuration.ProjectModel.Name}'. Do you want to sync with the current project?`)
            .subscribe(state => {
              if (state.action === 'OK') {
                const syncCommand = new SyncProjectEntityToCompanyCommand(true);
                this.commandService.executeCommand(syncCommand).pipe().subscribe(syncCommandState => {
                  console.log(syncCommandState);
                  this.openEditor(event);
                });
              } else {
                this.openEditor(event);
              }
            });
        } else {
          this.openEditor(event);
        }
      });
      return;
    }
    this.openEditor(event);
  }

  public openEditor(event) {
    const minWidth = '800px';
    const maxWidth = '800px';
    if(event.fieldDefinition.dataType === 'Attachment'){
      if(event.fieldDefinition.metaData['DirectoryPath']) {
        event.fieldDefinition.metaData['DirectoryPath'] = event.fieldDefinition.metaData['DirectoryPath'].replace('[CASE_ID]', event.item.cells['CaseId'].value);
      }
    }
    this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition, minWidth, maxWidth, this.sourceType, this.fieldHistorySourceType).subscribe(state => {
      console.log('After Edit', state);
      if (state.action === 'OK') {
        this.saveFieldDefinition(state.data.input.fieldDefinition, event.fieldSection);

        const item = {id: event.item.id, fieldValues: {}};
        const value = event.item.cells[event.fieldDefinition.key].value;
        item.fieldValues[event.fieldDefinition.key] = value;

        if(event.fieldDefinition.dataType === 'Attachment'){
          item.fieldValues[`${event.fieldDefinition.key}FileName`]= event.item.cells['fileName'];
        }

        const command = new UpdatePreArrangementCommand(item);
        const currentBasket = BasketProvider.getCurrentBasket();
        switch (currentBasket.id){
          case BasketId.Mexico:
            command.IsHallmarkAutomatedCopy = true;
            break;
          default:
        }
        this.commandService.executeCommand(command).pipe().subscribe(commandState => {
          if(commandState.Payload.FieldValues[`${event.fieldDefinition.key}NoteAvailable`]){
            this.snackBarService.showInformation(commandState.Payload.FieldValues[`${event.fieldDefinition.key}NoteAvailable`]);
          }
          this.invalidateSubject.invalidate();
        });
      }
    });
  }

  saveFieldDefinition(fieldDefinition: any, selectedFieldSection: any) {
    let fieldSettings = null;
    if (fieldDefinition && fieldDefinition.configKey) {
      const fieldConfig = Configuration.getSmartGridConfig(fieldDefinition.configKey);
      if (fieldConfig && fieldConfig.FieldSettings) {
        fieldSettings = fieldConfig.FieldSettings;
      }
    }
    if (fieldSettings) {
      const rootUrlKey = Configuration.getSmartGridConfig(this.sourceType).RootUrlKey;
      const url = `${Configuration.getConfig(rootUrlKey)}FieldSection/UpdateFieldDefinition`;
      const config = Configuration.getSmartGridConfig(this.sourceType);
      if (config) {
        const sourceType = config.SourceType;
        const updateFieldDefinitionCommand = new UpdateFieldDefinitionCommand([fieldDefinition], selectedFieldSection.id, ParticleConfig.ApplicationId, sourceType, true,
          url, !Configuration.getSmartGridConfig(this.sourceType).IsCompanySpecific);
        this.commandService.executeCommand(updateFieldDefinitionCommand).pipe().subscribe(commandState => {
          this.invalidateSubject.invalidate();
        });
      }
    }
  }
  private handleItemClick(event: any) {
    console.log('handle click');
    const participantsId = this.formatFieldDefinitionKey(event.fieldDefinition.key);
    const url = `dac6-reporter/participants/${participantsId}/${event.item.cells['CaseId'].displayText}`;
    this.router.navigate([url]);
  }
  private formatFieldDefinitionKey(key: string) {
    return  key === 'RelevantTaxpayers' ? 'relevant-taxpayers' : (key === 'Intermediaries' ? 'intermediaries' : 'other-persons');
  }
  navigateToCaseFolder(event: any) {
    console.log('navigateToCaseFolder', event);
    if (event.action && event.action.tags.length) {
      let relativePath = event.action.tags[0];
      const caseId = event.item.cells['CaseId'].displayText;
      relativePath = relativePath.replace('[CASE_ID]', caseId);
      console.log('rellativePath', relativePath);
      // const relativeUrl$ = this.queryState.pipe(select(getQueryResponse, 'UrlByRelativePath')).pipe(take(2));
      // relativeUrl$.subscribe(state => {
      //   console.log('RelativeUrl', state);
      //   if (state) {
      //     console.log('Inside Routing ', state);
      //     this.router.navigateByUrl(state);
      //   }
      // });

      // QueryProvider.invokeQuery(this.queryState, 'UrlByRelativePath', {'[RELATIVE_PATH]': relativePath});
      this.fileStoreCommonService.navigateToClientFolderUsingRelativepath(relativePath);
    }
  }
  startConversationActivity(event) {
    let startConversationCommand = new PlatformCommand('OpenConversationActivityCommand','Dac6Api');
    var sourceKey = BasketProvider.getRootSourceKeyBySourceType(event.item.type);
    startConversationCommand.fieldValues['SourceType'] = sourceKey;
    // viewDocumentCommand.fieldValues[sourceKey+"Id"] = event.item.id;
    startConversationCommand.fieldValues['CaseId'] = event.item.id;
    this.commandService.executePlatformCommand(startConversationCommand).pipe(take(1)).subscribe(response => {
        console.log('commandState', response);
      },
      error => {
        console.error('Failed to basket manage section', error);
      });
  }
  getChatForThisCase(event) {
    const sourceInfoDictionary = {
      'sourceInfoDictionary': {
        CaseGuid: event.item.cells['CaseGUID'].value,
        caseId: event.item.cells['CaseId'].displayText
      }
    };
    const createChatConversationCommand = new CreateChatConversationCommand(
      '[COMPANY_ID]-chat',
      `${event.item.cells['CaseId'].displayText}`,
      true,
      0,
      'DAC6',
      [],
      true,
      event.item.cells['CaseGUID'].value,
      sourceInfoDictionary
    );
    createChatConversationCommand.scope = ContentScope.Company;
    this.collaborationStore.dispatch(new CreateChatConversationAction(createChatConversationCommand, ConversationComponentName));
  }
  archiveSingle(caseGuid: string) {
    const dialogModel = DialogModel.create('Archive Case',
      'ArchiveDialogComponent',
      {}, '500px', '490px', false);
    dialogModel.okCaption = 'Archive';
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unSubscribe$)).subscribe(data => {
      if (data.action === 'OK') {
        console.log(data.data.input['comment']);
        const command = new ArchiveSingleCaseCommand(caseGuid, data.data.input['comment']);
        this.fuseSplashScreenService.show();
        this.commandService.executeCommand(command).subscribe(state => {
          this.invalidateSubject.invalidate();
          this.fuseSplashScreenService.hide();
        });
      }
    });
  }
  unarchiveCase(caseGuid: string) {
    const message = 'You can unarchive this Case if you need to make additional edits, or if it was archived by mistake. Please ensure that any associated Tasks and Reports are updated and re-opened as required.';
    const question = 'Are you sure you want to unarchive this DAC6 Case?';
    this.dialogService.showConfirmDialog('Unarchive', 'Unarchive', 'Cancel', message, question ).subscribe(data => {
    if (data.action === 'OK') {
    const command = new UnarchiveCaseCommand(caseGuid);
    this.fuseSplashScreenService.show();
    this.commandService.executeCommand(command).subscribe(state => {
        this.invalidateSubject.invalidate();
        this.fuseSplashScreenService.hide();
    });
  }});
  }
  private copyCase(event: any) {
    const dialogModelTitle = 'Copy Case (' + event.item.cells.CaseId.displayText + ')';
    const dialogModel: DialogModel = DialogModel.create(
      dialogModelTitle,
      'CopyCaseDialogComponent', {'caseId': event.item.cells.CaseId.displayText, 'caseType': 'Pre-Arrangement', 'disableTypeChange': true, 'isReadOnly': event.item.isReadOnly, 'isArcived' : event.item.cells.Archived.value},
      '600px',
      '700px',
    );
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      console.log(res);
      if (res.action === 'OK') {
        switch (res.data.input.caseType) {
          case 'Pre-Arrangement':
            if (res.data.input.specifyField) {
              res.data.input['title'] = event.item.cells.Title.value;
              this.openSelectFieldDialog(res.data.input.selectedCase, 'prearrangementmodel', 'PreArrangement', res, event.item.id, res.data.input.copyCount);
            } else {
              this.addPreArrangementFromExistingCaseId(event.item.cells.Title.value, event.item.id, res.data.input.archiveExisting, res.data.input.caseIdUsedforCorrection, res.data.input.copyCount );
            }
            break;
        }
      }

    });
  }
  private openSelectFieldDialog(selectedCase: string, dbmodelType: string, sourceType: string, caseData: any, existingId: string, copyCount: number = 1) {
    const dialogModel: DialogModel = DialogModel.create(
      'Select Data',
      'VirtualGridDialogComponent', {sourceKey: 'Dac6-RowFieldData-Config', params: {'rowId': selectedCase, 'dbmodelType': dbmodelType, 'sourceType': sourceType}},
    );
    dialogModel.isFullscreen = true;
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      if (res.action === 'OK') {
        switch (sourceType) {
          case 'PreArrangement':
            this.addPreArrangementFromExistingCaseId(caseData.data.input.title, existingId, caseData.data.input.archiveExisting, false, copyCount, res.data.input.selectedFields, false);
            break;
        }
      }
    });
  }
  addPreArrangementFromExistingCaseId(title: string, existingCaseId: string, archiveExisting: boolean, caseIdForCorrection: boolean, copyCount?: number, selectedFields?: string[],  copyAllFields: boolean = true) {
    this.fuseSplashScreenService.show();
    // title, selectedCase, archiveExisting, copyCount,


    this.commandService.executeCommand(new CreatePreArrangementFromExistingCaseCommand(title, existingCaseId, archiveExisting, caseIdForCorrection, copyCount, selectedFields, copyAllFields)).pipe().subscribe(state => {
      this.fuseSplashScreenService.hide();
      this.router.navigateByUrl(`dac6-reporter/pre-arrangement/detail/${state.Payload.Id}`);
    });
  }
  private trackCaseActiviy(event: any) {
    this.platformSidebarStore.dispatch(new SetActivityFeedAction({type: 'ReferenceCode', id: event.item.cells['ReferenceCode'].value, title: event.item.cells['CaseId'].value, isDefault: false, isUserAction: true}));
  }
  createCase() {
    const dialogModel: DialogModel = DialogModel.create(
      'Create Case',
      'CreateCaseDialogComponent',
      {'caseType': 'PreArrangement', disableTypeChange: true},
      '600px',
      '700px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      console.log(res);
      if (res.action === 'OK') {
        switch (res.data.input.caseType) {
          case 'PreArrangement':
            if (res.data.input.specifyField) {
              res.data.input.archiveExisting = false;
              this.openSelectFieldDialog(res.data.input.selectedCase, 'prearrangementmodel', 'PreArrangement', res, res.data.input.selectedCase);
            } else {
              if (res.data.input.selectedCase) {
                this.addPreArrangementFromExistingCaseId(res.data.input.title, res.data.input.selectedCase, false, false);
              } else {
                this.addPreArrangement(res.data.input.title);
              }
            }
            break;
          case 'Arrangement':
            this.addArrangement(res.data.input.title);
            break;
        }
      }
    });
  }
  addPreArrangement(title: string) {
    this.fuseSplashScreenService.show();
    this.commandService.executeCommand(new CreatePreArrangementCommand(title)).pipe().subscribe(state => {
      this.fuseSplashScreenService.hide();
      this.router.navigateByUrl(`dac6-reporter/pre-arrangement/detail/${state.Payload.Id}`);
    });
  }
  addArrangement(title: string) {
    this.fuseSplashScreenService.show();
    this.commandService.executeCommand(new CreateArrangementCommand(title)).pipe().subscribe(state => {
      this.fuseSplashScreenService.hide();
      this.router.navigateByUrl(`dac6-reporter/arrangement/${state.Payload.Id}`);
    });
  }
  import() {
    this.router.navigateByUrl('dac6-reporter/pre-arrangement/import');
  }
  exportPreArrangement() {
    this.router.navigate(['export'], {
      relativeTo: this.activatedRoute,
      queryParams: {
        includeArchives: this.showArchived
      }
    });
  }
  manageSection() {
    const command = new PlatformCommand('CreateManageFieldMagicLinkCommand', 'Dac6Api');
    command.fieldValues['SourceType'] = Configuration.getBasketMappedSourceType('PreArrangement');
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(response => {
      console.log('commandState', response);
      if (response.fieldValues['RedirectUrl']) {
        this.router.navigateByUrl(response.fieldValues['RedirectUrl']);
      }
      },
      error => {
        this.fuseSplashScreenService.hide();
        console.error('Failed to prearrangement managesection ', error);
      });
  }
  archive() {
    const selectionKey = 'prearrangement-archive-cases';
    const input = {
      ['SELECTION_KEY'] : selectionKey,
      ['ITEMS_SOURCE_TYPE']: this.sourceType
    };
    const filterId = selectionKey;
    const basketSourceType = BasketProvider.getBasketMappedSourceType(this.sourceType);
    const preCommand = new SaveSelectedCaseModelsInLeftSideOfTheTransferboxCommand(selectionKey, filterId, basketSourceType);
    this.commandService.executeCommand(preCommand).subscribe(prestate => {
      if (prestate) {
        const dialogModel = DialogModel.create('Select Case(s)', 'EntitySelectorDialogComponent', {
          filterId: selectionKey,
          filterTemplateId: 'prearrangement-archive-filter',
          apiKey: 'Dac6Api',
          input: input
        });
        dialogModel.okCaption = 'Next';
        dialogModel.minWidth = '1200px';
        dialogModel.maxWidth = '1200px';

        this.dialogService.showOkCancelDialog(dialogModel)
          .pipe(takeUntil(this.unSubscribe$))
          .subscribe(actionState => {
            if (actionState && actionState.action === 'OK') {
              this.showArchiveDialog(filterId, selectionKey);
            }
          });
      }
    });
  }
  showArchiveDialog(filterId, selectionKey) {
    const dialogModel = DialogModel.create('Archive Case(s)',
      'ArchiveDialogComponent',
      {}, '500px', '490px', false);
    dialogModel.okCaption = 'Archive';
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unSubscribe$)).subscribe(data => {
      if (data.action === 'OK') {
        console.log('Clicked Okay');
        console.log(data.data.input['comment']);
        const command = new ArchiveCaseCommand(filterId, selectionKey, this.sourceType, data.data.input['comment']);
        this.fuseSplashScreenService.show();
        this.commandService.executeCommand(command).subscribe(state => {
          this.invalidateSubject.invalidate();
          this.fuseSplashScreenService.hide();
        });
      }
    });
  }
  sendShowArchivedActivityCommand() {
    let showArchivedCommand = new PlatformCommand('ShowArchivedCommand','Dac6Api');
    var sourceKey = BasketProvider.getRootSourceKeyBySourceType(this.sourceType);
    showArchivedCommand.fieldValues['SourceType'] = sourceKey;
    showArchivedCommand.fieldValues['IsArchived'] = this.showArchived;
    // viewDocumentCommand.fieldValues[sourceKey+"Id"] = event.item.id;
    this.commandService.executePlatformCommand(showArchivedCommand).pipe(take(1)).subscribe(response => {
        console.log('commandState', response);
      },
      error => {
        console.error('Failed to basket manage section', error);
      });
  }
  showArchivedChanged(command) {
    this.showArchived = command.isChecked;
    this.fuseSplashScreenService.show();
    console.log('showArchivedChanged');
    this.selectedTab.tabData['SHOW_ARCHIVED'] = command.isChecked;
    const params = this.particleCacheService.getUserPreferenceGridSetting(Dynamic_Grid_Data_Request_Parameters, this.sourceType);
    params['SHOW_ARCHIVED'] = this.showArchived;
    this.particleCacheService.saveUserPreferenceGridSetting(Dynamic_Grid_Data_Request_Parameters, this.sourceType,params);
    this.sendShowArchivedActivityCommand();
    this.invalidateSubject.invalidate();
    this.fuseSplashScreenService.hide();
  }
  startDataSurvey() {
    const { flag } = BasketProvider.getCurrentBasket();
    const bucket = flag === 'MX' ? '-MX' : '';
    const title = `Pre-Arrangement${bucket}`;
    const parameters = {'SourceTypes': [`PreArrangement${bucket}`, `Relevant-Taxpayers${bucket}`, `Intermediaries${bucket}`, `Other-Persons${bucket}`]};
    this.dialogService.createOrLoadDefaultSurveyTemplate(title, false, false, null, parameters);
  }
  private executeCommandToApi(command: PlatformCommand) {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          console.log('Command Response', commandResponse);
          this.fuseSplashScreenService.hide();
          if (commandResponse.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
          } else {
            this.invalidateSubject.invalidate();
          }
        },
        error => {
          console.error('Failed ToolBarComponent command', error);
          this.fuseSplashScreenService.hide();
        });
    }
  }
  destroy(): void {
  }

  private cleanupWorkFlow(command: PlatformCommand) {
    if (this.magicLinkModel.fieldValues['WorkflowTool'] === 'Export') {
      this.store.dispatch(new CleanWorkflowDataAction(command.fieldValues['SelectedTab'].tabData['WorkFlowId']));
      this.router.navigateByUrl(command.fieldValues['SelectedTab'].tabData['ReRouteUrl']);
    }
    if (this.magicLinkModel.fieldValues['WorkflowTool'] === 'Import') {
      this.router.navigateByUrl(command.fieldValues['SelectedTab'].tabData['ReRouteUrl']);
    }
  }

}
